export default __webpack_public_path__ + "static/media/logo.d27c58d2.png";